<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Islet Specific Details EMR-OATS Preview
    </template>
    <template #body>
      <div class="sections">
        <div class="row">
          <div class="col-3 fieldName">
            In EMR
          </div>
          <div class="col-3 fieldName">
            In OATS
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="infusionDate"
              disabled
              label="Infusion Date"
              :class="{ highlightField: isDifferent(infusionDate, infusionDateOATS) }"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="infusionDateOATS"
              disabled
              label="Infusion Date"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="donorId"
              disabled
              label="Donor ID"
              :class="{ highlightField: isDifferent(donorId, donorIdOATS) }"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="donorIdOATS"
              disabled
              label="Donor ID"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-3">
            <ADSTextInput
              v-model="finalInfusion"
              disabled
              label="Final Infusion"
              :class="{ highlightField: isDifferent(finalInfusion, finalInfusionOATS) }"
            />
          </div>

          <div class="col-3">
            <ADSTextInput
              v-model="finalInfusionOATS"
              disabled
              label="Final Infusion"
            />
          </div>
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';

export default {
  name: "IsletSpecificSectionDetailsEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      infusionDate: this.getInfusionDate( this.patientBundle ),
      donorId: this.getDonorId( this.patientBundle ),
      finalInfusion: this.getFinalInfusion( this.patientBundle ),
      infusionDateOATS: this.getInfusionDateOATS( this.patientBundleOATS ),
      donorIdOATS: this.getDonorIdOATS( this.patientBundleOATS ),
      finalInfusionOATS: this.getFinalInfusionOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getSmartdataComponentValue( patientBundle, observationCode, valuePath = 'valueString' ) {
      const entries = patientBundle?.entries;
      if( !entries?.length ) {
        return null;
      }
      const smartdataGroups = entries.filter( ( n ) =>
        _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
        _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );
      const group = smartdataGroups[0];
      if( !group ) {
        return null;
      }
      const match = group.filter( ( n ) => _.get( n, 'resource.code.coding[0].code' ) === observationCode );
      if( !match[0] ) {
        return null;
      }
      const raw = _.get( match[0], `resource.component[0].${valuePath}` );
      if( raw === null || raw === undefined ) {
        return null;
      }
      return String( raw );
    },
    getInfusionDate( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8203', 'valueDateTime' );
    },
    getDonorId( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8204' );
    },
    getFinalInfusion( patientBundle ) {
      return this.getSmartdataComponentValue( patientBundle, 'SK#8205' );
    },
    getInfusionDateOATS( patientBundleOATS ) { 
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 7 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        if( journey[ 0 ].pancreas_islets_procedures && journey[ 0 ].pancreas_islets_procedures[ 0 ] ){
          return journey[ 0 ].pancreas_islets_procedures[ 0 ].infusion_date;
        }
      }
    },
    getDonorIdOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 7 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        if( journey[ 0 ].pancreas_islets_procedures && journey[ 0 ].pancreas_islets_procedures[ 0 ] ){
          return journey[ 0 ].pancreas_islets_procedures[ 0 ].donor_id;
        }
      }
    },
    getFinalInfusionOATS( patientBundleOATS ) {
      let journey = patientBundleOATS.journeys?.filter( ( n ) => ( n.organ_code === 7 && n.state !== 'cancelled' && n.completed === false ) );
      if( journey && journey[ 0 ] ) {
        if( journey[ 0 ].pancreas_islets_procedures && journey[ 0 ].pancreas_islets_procedures[ 0 ] ){
          return journey[ 0 ].pancreas_islets_procedures[ 0 ].final_infusion;
        }
      }
    },
    isDifferent( a, b ) {
      return String( a ?? '' ).trim()?.toLowerCase() !== String( b ?? '' ).trim()?.toLowerCase();
  },
  },
};
</script>

<style scoped>

/* .card {
  height: 560px;
} */

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 400px;
  width: 1400px;
  /* overflow: scroll; */
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  /* padding-top: 5.5px; */
  /* padding-bottom: 2.5px; */
  /* padding-right: 15px; */
  padding-inline-start: 2%;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

.highlightField :deep(.afflo-ds-form-control) {
  border: 2px solid red;
}

</style>
